import { getOnboardingsApplications } from "features/ecommerce/api";
import { withLoader } from "features/auth/helpers";

const loader = withLoader(getOnboardingsApplications);

export default loader;
